import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Home from "./pages/Home";
import Art from "./pages/Art";
import Designs from "./pages/Designs";
import TechStack from "./pages/TechStack";
import Life from "./pages/Life";

// Blog
import Blog from "./pages/Blog";
import GetToThePoint from "./pages/blog/GetToThePoint";
import GoogleFoobarChallenge from "./pages/blog/GoogleFoobarChallenge";
import MathematicalArtificialIntelligence from "./pages/blog/MathematicalArtificialIntelligence";
import HowIConvertedMyReactDjango from "./pages/blog/HowIConvertedMyReactDjango";
import MyAgenticCodingSetup from "./pages/blog/MyAgenticCodingSetup";

// Reviews
import Reviews from "./pages/Reviews";
import GameReviews from "./pages/reviews/GameReviews";
import ToiletReviews from "./pages/reviews/ToiletReviews";
import AlbumReviews from "./pages/reviews/AlbumReviews";
import BookReviews from "./pages/reviews/BookReviews";

// Games
import Games from "./pages/Games";

// Apps
import Apps from "./pages/Apps"
// Cogio App
import CogioApp from "./pages/apps/CogioApp";
import CogioFeedback from "./pages/apps/cogio/CogioFeedback";
import CogioBugReport from "./pages/apps/cogio/CogioBugReport";
import CogioSupport from "./pages/apps/cogio/CogioSupport";
import PrivacyPolicy from "./pages/apps/cogio/CogioPrivacyPolicy";
import CogioLicense from "./pages/apps/cogio/CogioLicense";
// Fundatio App
import FundatioApp from "./pages/apps/FundatioApp";
import FundatioFeedback from "./pages/apps/fundatio/FundatioFeedback";
import FundatioBugReport from "./pages/apps/fundatio/FundatioBugReport";
import FundatioSupport from "./pages/apps/fundatio/FundatioSupport";
import FundatioPrivacyPolicy from "./pages/apps/fundatio/FundatioPrivacyPolicy";
import FundatioLicense from "./pages/apps/fundatio/FundatioLicense";

export default function App() {
    return (
        <Router>
            <div className="App">
                <Routes>
                    <Route path="/" element={<Home/>}/>
                    <Route path="/art" element={<Art/>}/>
                    <Route path="/designs" element={<Designs/>}/>
                    <Route path="/tech-stack" element={<TechStack/>}/>
                    <Route path="/life" element={<Life/>}/>

                    {/*Blog*/}
                    <Route path="/blog" element={<Blog/>}/>
                    <Route path="/blog/get-to-the-point" element={<GetToThePoint/>}/>
                    <Route path="/blog/google-foobar-challenge" element={<GoogleFoobarChallenge/>}/>
                    <Route path="/blog/mathematical-artificial-intelligence"
                           element={<MathematicalArtificialIntelligence/>}/>
                    <Route path="/blog/how-i-converted-my-react-django-setup-into-a-static-github-pages-site"
                           element={<HowIConvertedMyReactDjango/>}/>
                    <Route path="/blog/my-agentic-coding-setup"
                           element={<MyAgenticCodingSetup/>}/>

                    {/*Reviews*/}
                    <Route path="/reviews" element={<Reviews/>}/>
                    <Route path="/reviews/game" element={<GameReviews/>}/>
                    <Route path="/reviews/toilet" element={<ToiletReviews/>}/>
                    <Route path="/reviews/album" element={<AlbumReviews/>}/>
                    <Route path="/reviews/book" element={<BookReviews/>}/>

                    {/*Games*/}
                    <Route path="/games" element={<Games/>}/>

                    {/*Apps*/}
                    <Route path="/apps" element={<Apps/>}/>
                    {/*Cogio App*/}
                    <Route path="/apps/cogio" element={<CogioApp/>}/>
                    {/*<Route path="/apps/cogio/feedback" element={<CogioFeedback/>}/>*/}
                    {/*<Route path="/apps/cogio/bug-report" element={<CogioBugReport/>}/>*/}
                    <Route path="/apps/cogio/support" element={<CogioSupport/>}/>
                    <Route path="/apps/cogio/privacy-policy" element={<PrivacyPolicy/>}/>
                    <Route path="/apps/cogio/license" element={<CogioLicense/>}/>
                    {/*Fundatio App*/}
                    <Route path="/apps/fundatio" element={<FundatioApp/>}/>
                    {/*<Route path="/apps/fundatio/feedback" element={<FundatioFeedback/>}/>*/}
                    {/*<Route path="/apps/fundatio/bug-report" element={<FundatioBugReport/>}/>*/}
                    <Route path="/apps/fundatio/support" element={<FundatioSupport/>}/>
                    <Route path="/apps/fundatio/privacy-policy" element={<FundatioPrivacyPolicy/>}/>
                    <Route path="/apps/fundatio/license" element={<FundatioLicense/>}/>
                </Routes>
            </div>
        </Router>
    );
}